import React from "react";
import { items } from "../itemsDB";
import { Modal } from "antd";
import { useState } from "react";
import Item from "./Item";
import "./Content.css";
import { Link } from "react-router-dom";

function Content() {
  //   const [isModalVisible, setModalVisible] = useState(false);
  const allItems = items;
  return (
    <>
      <div className="content">
        <h1 className="h1-content">Products</h1>
        {allItems.map((e, i) => {
          return (
            <>
              <Link to="/product" state={e} className="login">
                <Item name={e.name} details={e.about} button={e.price} />
              </Link>
            </>
          );
        })}
      </div>
    </>
  );
}

export default Content;
